export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пошук"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Натисніть , щоб вибрати стовпці, що відображаються."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Відображувані стовпці"])}
}